import React, { useEffect, useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';
import sortBy from 'lodash/sortBy'
import usePreviousRef from 'hooks/usePreviousRef';
import { BreadcrumbsDispatchContext, UPDATE_BREADCRUMBS } from 'context/breadcrumbsContextWrapper';
import NavLink from '../NavLink/NavLink.component';


import {subitemWrap } from './navitem_styles.module.scss' 
   

const containsPage = (page, link) => { 
    if (`/${page.link}` === link) {
        return true;
    }

    if (page.subItems == null || page.subItems.length === 0) {
        return false;
    }

    return page.subItems.some((child) => containsPage(child, link));
};

function NavItem({ 
  navItem, 
  __depth: depth = 0
}){

  const dispatch = useContext(BreadcrumbsDispatchContext);

  const location = useLocation();
  const pathname = location.pathname

  const containsCurrentPage = useMemo(
    () => containsPage(navItem, pathname),
    [navItem, pathname]
  );

  const isCurrentPage = `/${navItem.link}` === pathname;
  const shouldExpand = isCurrentPage || containsCurrentPage;
  const hasChangedPage = pathname !== usePreviousRef(pathname);
  const [isExpanded, setIsExpanded] = useState(shouldExpand);
  const toggle = (expanded) => !expanded;

  useEffect(() => {
    if (hasChangedPage) {
      setIsExpanded(shouldExpand);
    }
    if(shouldExpand){
      dispatch({
        type: UPDATE_BREADCRUMBS,
        payload: `${navItem.name}==${navItem.link}`
      })
    }
  }, [hasChangedPage, shouldExpand, dispatch, navItem.link, navItem.name]);

  return (
    <li
      style={{borderLeft: '1px solid #ddd'}}
    >
      <NavLink
        active={isCurrentPage}
        to={navItem.link}
        isExpanded={isExpanded}
        expandable={navItem?.subItems?.length > 0}
        onClick={() => {
          setIsExpanded(isCurrentPage || !navItem.link ? toggle : true);
        }}
        onToggle={() => setIsExpanded(toggle)}
      >
        {navItem.name}
      </NavLink>

      {isExpanded && navItem?.subItems?.length > 0 &&
        <ul className={subitemWrap}>
          {sortBy(navItem.subItems, 'order')?.map((child) => (
                    <NavItem
                      key={child.link || child.name}
                      navItem={child}
                      __depth={depth + 1}
                    />))}
        </ul>
      }
    </li>
  );
};

const navItem = PropTypes.shape({
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  subItems: PropTypes.arrayOf(PropTypes.object),
});

NavItem.defaultProps = {
    __depth: 0,
}

NavItem.propTypes = {
  __depth: PropTypes.number, 
  navItem: navItem.isRequired, 
};  


export default NavItem;
